/*
  Butonul „Adaugă în coș" de pe cardurile ONE ([data-one-gocart]).

  Cererea: clicul pe card duce direct in cos. Formularul e unul normal de
  Shopify (/cart/add cu return_to=/cart), deci merge si fara JavaScript.
  one-cart.js prinde toate formularele din carduri si le trimite pe AJAX, cu
  un mesaj; aici oprim doar asta pentru formularele de card, inaintea lui
  (ascultam pe window, in faza de captura), si lasam formularul sa plece.
*/
(function () {
  'use strict';
  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (!(f instanceof HTMLFormElement) || !f.hasAttribute('data-one-gocart')) return;
    e.stopImmediatePropagation();
    var b = f.querySelector('button[type="submit"]');
    if (b) {
      b.dataset.eticheta = b.textContent;
      b.textContent = 'Se adaugă…';
      b.setAttribute('aria-busy', 'true');
    }
  }, true);

  /* La intoarcerea cu „Înapoi", pagina poate veni din cache cu butonul
     ramas pe „Se adaugă…". Il readucem la normal. */
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('form[data-one-gocart] button[aria-busy]').forEach(function (b) {
      b.textContent = b.dataset.eticheta || 'Adaugă în coș';
      b.removeAttribute('aria-busy');
    });
  });
})();

/*
  Pe pagina de contact: subiectul si mesajul pot veni completate din link
  (?subiect=...&mesaj=...). Le foloseste butonul „Ia în chirie" din
  calculatorul de cost pe ceasca. Completam doar campurile goale, ca sa nu
  stergem ce a scris omul.
*/
(function () {
  'use strict';
  function completeaza() {
    var q;
    try { q = new URLSearchParams(location.search); } catch (e) { return; }
    var subiect = q.get('subiect'), mesaj = q.get('mesaj');
    if (!subiect && !mesaj) return;
    var f = document.getElementById('scrie-ne');
    if (!f) return;
    var s = f.querySelector('[name="contact[subiect]"]'), m = f.querySelector('[name="contact[body]"]');
    if (s && subiect && !s.value) s.value = subiect.slice(0, 200);
    if (m && mesaj && !m.value) m.value = mesaj.slice(0, 1500);
    var firma = f.querySelector('input[name="contact[tip]"][value*="horeca" i], input[name="contact[tip]"][value*="birou" i]');
    if (firma && subiect && /^Chirie/.test(subiect)) { firma.checked = true; firma.dispatchEvent(new Event('change', { bubbles: true })); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', completeaza); else completeaza();
})();
